<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <div class="top wrap clear">
            <h2 class="bold mb-10 float-left">예복습동영상</h2>
        </div>
        <div class="page-top">
            <div class="wrap">
                <div class="review-top pb-20">
                    <div class="clear">
                        <p class="w-15per">교재</p>
                        <p class="w-85per txt-left"><a :href="info.mov_book_url">{{ info.mov_book }}</a></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" v-show="!isvideo">
            <div class="review-wrap">
                <ul>
                    <li v-for="(item,index) in datalist" :key="index" v-on:click="showVideo(item, 1, index)" class="cur-pointer">
                        <span v-if="item.study1!='Y'" class="gra cur-pointer"><img src="../assets/img/review_list_icon_empty.png" />Lesson {{index+1}}) {{ item.title }}</span>
                        <span v-else><img src="../assets/img/review_list_icon.png" />Lesson {{index+1}}) {{ item.title }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="review-wrap-div" v-show="isvideo">
            <div class="review-wrap">
                <div class="review-item-title">
                    <p>{{ cvideo.title }}</p>
                </div>
                <div class="review-video wrap">
                    <img src="../assets/img/review-arrow-left.png" v-if="cvideo.prev>0" class="arrow-left" @click="prevVideo" />
                    <video type="video/mp4" poster="../assets/img/empty_thumnail.jpg" autoplay loop controls id="svideo" class="video-box"></video>
                    <img src="../assets/img/review-arrow-right.png" v-if="cvideo.next>0" class="arrow-right" @click="nextVideo" />
                </div>
            </div>
            <div class="wrap">
                <div class="mt-10">
                    <button class="btn-base-white" @click="hideVideo()">목록</button>
                </div>
            </div>
        </div>

    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
export default {
    name: 'ReviewList',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    data: () => ({
        classid: "",
        isvideo: false,
        cvideo: {
            title: ""
        },
        cidx: 0,
        info: {},
        total: 0,
        datalist: [],
        source: ""
    }),
    mounted() {
        //    this.doc_del_rendar();
        this.classid = this.$route.query.classid;
        this.initPage();
    },
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
    methods: {
        hideVideo: function () {
            console.log("hide video - stop!");
            var video = document.getElementById('svideo');
            video.load();
            this.isvideo = false;
        },
        prevVideo: function () {
            console.log("prev video - play!");
            var idx = this.cidx;
            this.showVideo(this.datalist[idx - 1], 1, idx - 1);
        },

        nextVideo: function () {
            console.log("next video - play!");
            var idx = this.cidx;
            this.showVideo(this.datalist[idx + 1], 1, idx + 1);
        },
        showVideo: function (itm, seq, idx) {
            console.log("show video - play!");
            var video = document.getElementById('svideo');
            // this.source = document.createElement('source');

            this.cidx = idx;
            this.cvideo = itm;

            if ((itm.excess_video_url && seq == 1) || (itm.excess_video_url2 && seq == 2)) {
                this.isvideo = true;
            } else {
                this.isvideo = false;
            }

            var src = itm.excess_video_url;
            if (seq == 2) src = itm.excess_video_url2;

            console.log(src);
            // this.source.setAttribute('src', src);

            video.pause();
            // video.appendChild(this.source);
            video.src = src;
            video.load();
            // video.play();

            var params = {
                classid: this.classid,
                ebook_seq: itm.ebook_seq,
                lesson_seq: itm.seq,
                isstudy: seq,
                uidx: localStorage.getItem("uidx"),
                tmr: Date.now()
            };

            var me = this;
            this.axios.post(this.$store.state.host + '/rest/mobile/viewvideo', params).then(function (res) {
                if (res.data.err == 0) {
                    console.log('load success');
                    if (seq == 2) {
                        me.cvideo.study2 = "Y";
                    } else {
                        me.cvideo.study1 = "Y";
                    }
                } else {
                    console.log('load failed');
                }
            });
        },
        initPage: function () {
            console.log("init page");

            var me = this;
            var params = {
                uidx: localStorage.getItem("uidx")
            }
            this.axios.get(this.$store.state.host + "/rest/mobile/classebooklist_new/" + me.classid, {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    me.info = res.data;
                    me.datalist = res.data.list;
                    me.total = res.data.total;
                    console.log(me.datalist);
                } else {
                    alert(res.data.err_msg);
                }
                me.is_loader = false;
            });
        },
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    padding-bottom: 60px;

    .top {
        padding-right: 20px;
        padding-top: 70px;
        background: url("../assets/img/top-bg.png") no-repeat right -80px;
        background-size: 300px;

        h2 {
            padding-bottom: 20px;
        }

        position: relative;

        .my-reason {
            position: absolute;
            right: 0;
            bottom: 15%;
        }
    }

    .page-top {
        border-bottom: 1px solid #E9E9E9;

        .review-top {

            div {
                background: #F5F5F5 0% 0% no-repeat padding-box;
                border: 1px solid #E9E9E9;
                border-radius: 10px;
                opacity: 1;
                width: 95%;
                margin: 0 auto;
                box-sizing: border-box;
                padding-top: 19px;
                padding-bottom: 19px;

                p {
                    float: left;
                    text-align: center;

                    &:first-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #B7B7B7;
                        opacity: 1;
                    }

                    &:last-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .wrap {
        .review-wrap {
            ul {
                li {
                    width: 100%;

                    span {
                        text-align: left;
                        font-size: 14px;

                        img {
                            margin-right: 10px;

                        }

                    }

                    span.gra {
                        color: #B7B7B7;
                    }

                    padding: 14px;
                    border-bottom: 1px dashed #E9E9E9;
                }

            }
        }
    }

    .review-wrap-div {
        width: 100%;

        .review-wrap {
            width: 100%;

            .review-wrap {}

            .review-item-title {
                font-weight: bold;
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
                padding-top: 20px;
                padding-bottom: 20px;
                text-align: center;
            }

            .review-video {
                width: 100%;
                position: relative;

                video {
                    width: 100%;
                }

                img {
                    position: absolute;
                }

                .arrow-left {
                    left: 20px;
                    top: 35%;
                    cursor: pointer;
                }

                .arrow-right {
                    cursor: pointer;
                    right: 20px;
                    top: 35%;
                }
            }
        }
    }
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {
    .class {
        width: 100%;

        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;

            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }

            &.wrap {
                width: 100%;
                padding-left: 5%;
            }
        }
        .review-wrap-div{
            .review-wrap{
                .review-video{
                    .arrow-right{
                        width: 45px;
                    }
                    .arrow-left{
                        width: 45px;
                    }
                }
            }
        }
    }
}
// .class .review-wrap-div .review-wrap .review-video .arrow-right[data-v-192f44c9]
</style>
